
import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import cloneDeep from 'lodash/cloneDeep';
import DeleteIcon from '../src/assets/trash.png';
import ProfileIcon from '../src/assets/profile.svg';
import GPTIcon from '../src/assets/chatgpt.png';
import LoadingGif from '../src/assets/loading.gif';




const App = () => {
  const [inputText, setInputText] = useState('');
  const [loading, setLoading] = useState(false);
  const [chats, setChats] = useState({});
  const [chatKey, setChatKey] = useState('');
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(()=>{
    if(chatKey == ''){
      document.title = "ChatGPT"
    }else{
      document.title = chatKey.charAt(0).toUpperCase() + chatKey.slice(1)
    }
  },[chatKey])

  useEffect(() => {
    const data = localStorage.getItem('chats');
    try {
      if (data) {
        setChats(JSON.parse(data));
      }
    } catch (error) {
      console.error('Error parsing JSON data from local storage:', error);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('chats', JSON.stringify(chats));
  }, [chats]);

  const handleInputChange = (e) => {
    setInputText(e.target.value);
  };

  const handleSendClick = async () => {
    const url = 'https://api-v2.longshot.ai/custom/api/generate/instruct';
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer 0ca665460cbf21d2f3260889e6e89bb11f3b464a',
    };

    const data = {
      text: inputText,
    };
    setChatKey(inputText);
    try {
      setLoading(true);
      const datas = cloneDeep(chats);

      const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
      });

      const responseDataForTheQuery = await response.json();

      datas[inputText] = responseDataForTheQuery;
      setChats(datas);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteChat = (chat) => {
    const updatedChats = cloneDeep(chats);
    delete updatedChats[chat];
    setChats(updatedChats);
    setChatKey('');
  };

  return (
    <Container>
      <SidebarContainer open={isSidebarOpen}>
        <>
          {isSidebarOpen&&
          <Button onClick={()=>{
            setChatKey("")
          }} 
          disabled={loading}>
            New Chat
          </Button>}
          {<Button onClick={toggleSidebar} >{isSidebarOpen ? 'Toggle Sidebar' : '>'}</Button>}
          {isSidebarOpen &&
            chats &&
            Object.keys(chats)
              .reverse()
              .map((chat, index) => (
                <ChatItem
                  key={index}
                  onClick={() => {
                    setChatKey(chat);
                    setInputText('');
                  }}
                  isSelected={chat === chatKey}
                >
                  {chat.charAt(0).toUpperCase() + chat.slice(1)}
                  <div className="delete-button">
                    <img
                      src={DeleteIcon}
                      alt='D'
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteChat(chat);
                      }}
                    />
                  </div>
                </ChatItem>
              ))}
        </>
      </SidebarContainer>
      <SearchBarContainer>
        <Header>
          LongShot AI 
        </Header>
        <ResponseBox>
          {chatKey && <NameIconContainer>
            <IconContainer src={ProfileIcon} /><>You</> 
            <h5>{chatKey.charAt(0).toUpperCase() + chatKey.slice(1)}</h5>
          </NameIconContainer>}
          {loading&& <img src={LoadingGif} alt='Loading' />}
          {chatKey && !loading && 
          <NameIconContainer>
            <IconContainer src={GPTIcon} /><>ChatGPT</>
            <ResponseContainer>
              {chats[chatKey].copies[0].content}
            </ResponseContainer>
            </NameIconContainer>}       
        </ResponseBox>
        <Spacer />
        <SearchBar>
            <Input
              type="text"
              value={inputText}
              onChange={handleInputChange}
              placeholder="Enter text..."
              disabled={loading}
            />
            <Button onClick={handleSendClick} disabled={loading}>
              {loading ? 'Sending...' : 'Send'}
            </Button>
            <Footer>ChatGPT can make mistakes. Consider checking important information.</Footer>
        </SearchBar>
      </SearchBarContainer>
    </Container>
  );
};

const NameIconContainer = styled.div`
  font:bold;
  font-size:24px;
`
const IconContainer = styled.img`
  height:24px;
  align-items:center;
`
const Footer = styled.div`
  font-size: 12px;
  text-align: center;
`
const Spacer = styled.div`
  flex-grow: 1;
`;

const Header = styled.div`
  font-size: 24px;
  margin:1vh 0 10vh 0;
`

const ResponseBox = styled.div`

`
const SearchBar = styled.div`
  margin:20px;
`


const Container = styled.div`
  display: flex;
  font-family: 'Arial', sans-serif;
  height: 100vh;
  overflow: hidden;
`;

const SidebarContainer = styled.div`
  width: ${({ open }) => (open ? '20%' : '0')};
  background-color: #1f1f1f;
  padding: 20px;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  transition: width 0.3s ease;
  ${'' /* overflow: scroll; */}
`;

const SearchBarContainer = styled.div`
  flex: 1;
  display: flex;
  height:100vh;
  flex-direction: column;
  padding: 16px;
  background-color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
`;

const Button = styled.button`
  width: 100%;
  padding: 10px;
  cursor: pointer;
  background-color: ${({ disabled }) => (disabled ? '#ccc' : '#0084ff')};
  color: #fff;
  border: none;
  border-radius: 5px;
  margin-bottom: 10px;
  font-size: 14px;

  &:disabled {
    cursor: not-allowed;
  }
`;

const ChatItem = styled.h3`
  cursor: pointer;
  margin: 0;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  font-size: 16px;
  color: #fff;
  position: relative;

 

  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: #2c2c2c;
      color: #fff;

      &:hover {
        background-color: #3a3a3a;
      }
    `}

  .delete-button {
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
  }

  .delete-button img {
    width: 20px; 
    height: 20px;
    border-radius: 50%;
    background-color: #2c2c2c;
    padding: 5px; 
    margin: 0; 
    font-weight: bold;
    font-size: 18px;
    color: #ccc;

    &:hover {
      background-color: #ff0000;
      color: #fff;
    }
  }
`;



const Input = styled.input`
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: none;
  border-bottom: 1px solid #ccc;
  outline: none;
  font-size: 16px;
`;

const ResponseContainer = styled.div`
  margin-top: 20px;
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
  font-size: 16px;
  background-color: #fff;
  height:30vh;
  overflow:scroll;
`;



export default App;
